import { Principal } from "@dfinity/principal"
import { getNFTActor } from "@psychedelic/dab-js"
import { StoicIdentity } from "ic-stoic-identity"
import { HttpAgent } from "@dfinity/agent"
const Actor = require("@dfinity/agent").Actor

const standard = "EXT" // ICPCS NFT standard
const canisterId = "j3dqa-byaaa-aaaah-qcwfa-cai" // ICPCS canister ID
let agent = ""

const getUserNFTs = async (principalId) => {
	agent = new HttpAgent({
		host: "https://ic0.app"
	})
	agent.fetchRootKey().catch(console.error)

	const NFTActor = getNFTActor({ canisterId, agent, standard }) // Initialize the DAB-js NFT actor
	let userTokens = await NFTActor.getUserTokens(Principal.fromText(principalId)) // Fetch all ICPCS tokens held by the user from the DAB list

	return { userTokens }
}

async function hasStakedTokens(principalId) {
	const response = await fetch(`https://api.icpcs.io/hasStakedTokens/${principalId}`);
	const body = await response.json();

	return JSON.stringify(body) === 'true';
}

async function hasTokens(principalId) {
	try {
		const tokens = await getUserNFTs(principalId);
		console.log(tokens);
		if (Object.keys(tokens).length) {
			return true;
		}
	} catch (error) {
		console.log("DEBUG: No NFTs found in wallet. Checking staking pool...");
		if (await hasStakedTokens(principalId)) {
			console.log("DEBUG: Staked token(s) found.")
			return true;
		}
	}
	console.log("DEBUG: No staked tokens found.")
	return false;
}

function displayNoTokenError(
	context = window.OSjs,
	message = 'ERR: WALLET_NOT_CONNECTED', 
	error = 'At least one ICPCS NFT is required for this functionality. Please first connect your wallet by clicking on the wallet icon and selecting a provider.') 
{
  context.make('osjs/dialog', 'alert', {
    type: 'error',
    title: 'Action Blocked',
    message: message,
    error: error
  }, () => {});
}

export { hasTokens, displayNoTokenError }
